import { updateDocumentTitle } from '@/services/ant-design-pro/api';
import { Form, Input, Modal, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface RenameDocumentModalProps {
  open: boolean;
  document?: Pick<API.ASPICEDocument, 'id' | 'title'> | null;
  onCancel: () => void;
  onSuccess?: () => void;
}

/** 修改文档名称 */
const RenameDocumentModal: React.FC<RenameDocumentModalProps> = ({
  open,
  document,
  onCancel,
  onSuccess,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ title: document?.title || '' });
    }
  }, [open, document?.id, document?.title, form]);

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (!document) return;

      setSubmitting(true);
      const res = await updateDocumentTitle(String(document.id), values.title);
      if (res.success) {
        message.success(t('pages.workProducts.updateTitleSuccess'));
        form.resetFields();
        onSuccess?.();
      } else {
        message.error(res.message || t('pages.workProducts.updateTitleFailed'));
      }
    } catch (error: any) {
      if (error?.errorFields) return;
      console.error('更新文档标题失败', error);
      message.error(t('pages.workProducts.updateTitleFailed'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title={t('pages.workProducts.renameDocument')}
      open={open}
      confirmLoading={submitting}
      onOk={handleOk}
      onCancel={handleCancel}
      width={500}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label={t('pages.workProducts.documentName')}
          name="title"
          rules={[
            {
              required: true,
              message: t('pages.workProducts.documentNameRequired'),
            },
          ]}
        >
          <Input placeholder={t('pages.workProducts.enterDocumentName')} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RenameDocumentModal;
